import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Activity } from 'src/app/modules/entities/activity';
import { Person } from 'src/app/modules/entities/person';
import { Setting } from 'src/app/modules/entities/setting';
import { ActivityService } from 'src/app/modules/services/activity.service';
import { PersonService } from 'src/app/modules/services/person.service';
import { SettingService } from 'src/app/modules/services/setting.service';
import { errorDescription, url } from 'src/app/modules/util/constants';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-create-activity',
  templateUrl: './create-activity.component.html',
  styleUrls: ['./create-activity.component.css']
})
export class CreateActivityComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private personService: PersonService, private settingService: SettingService, 
    private activityService: ActivityService, private messageService: MessageService) {
    this.urlId = this.route.snapshot.paramMap.get('id');
  }

  urlId: string | null;
  person: Person | undefined;
  activityPhrases: string[] = [];
  uploadUrl: string = environment.cfgApiBaseUrl + '/upload';
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  selectedIndex: number = -1;
  steps: MenuItem[] = [];
  activeStep: number = 0;
  selectedPhrase: string = '';
  loading: boolean = false;
  imagesInUse: string[] = [];

  ngOnInit(): void {
    if (this.urlId) {
      this.steps = [
        { label: 'Imagen', icon: 'pi pi-times' },
        { label: 'Saludo', icon: 'pi pi-trash'},
        { label: 'Revisar', icon: 'pi pi-check'}
      ]
      let count: number = 0;
      this.personService.getFullProfile(this.urlId, count).subscribe({
        next: response => {
          if (response.status === 'success') {
            this.person = response.data as Person;
            this.person.mediaContent = this.person.mediaContent?.filter(media => media.type !== '.mp4');
            if (this.person.activities) {
              for (let activity of this.person.activities) {
                this.imagesInUse.push(activity.fileName!);
              }
            }
          }
        }
      });
    }
  }

  loadPhrases() {
    this.settingService.getSettingByName('activity_phrases').subscribe({
      next: response => {
        if (response.status === 'success')
          this.activityPhrases = ((response.data as Setting).value as string).split('|');
        this.activityPhrases.sort(() => Math.random() - 0.5);
      }
    })
  }

  changeStep(event: number) {
    this.activeStep = event;
  }

  isInUse(index: number): boolean {
    return this.imagesInUse.includes(this.person?.mediaContent![index].fileName!);
  }

  selectImage(index: number) {
    this.selectedIndex = index;
    this.activeStep++;
    if (this.activityPhrases.length === 0)
      this.loadPhrases();
  }

  selectPhrase(phrase: string) {
    this.selectedPhrase = phrase;
    this.activeStep++;
  }

  clear() {
    this.selectedIndex = -1;
    this.activeStep = 0;
    this.selectedPhrase = '';
  }

  saveActivity() {
    this.loading = true;
    let media = this.person?.mediaContent![this.selectedIndex];
    media!.person = this.person?.url_id as string;
    let activity: Activity = {
      description: this.selectedPhrase,
      media: media
    };    
    this.activityService.postInteraction(activity).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({
            summary: 'Publicación exitosa',
            detail: 'Será visible por las próximas 24 horas',
            severity: response.status
          });
          this.router.navigate([url['perfil'], this.person?.url_id]);
        } else {
          this.messageService.add({
            summary: 'Ocurrió un error registrando el saludo',
            severity: response.status
          });
        }
        this.loading = false;
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

}
